module.exports = __webpack_public_path__ + "static/media/tides.e7b516e2.mp4";